package er.prateek.crossly.ui.screens.legal

import er.prateek.crossly.config.AppConfig
import er.prateek.crossly.config.LinksConfig
import er.prateek.crossly.di.AppContainer
import er.prateek.crossly.firebase.RemoteConfigKeys

/**
 * One policy document per surface -- Android carries AdMob/Play Billing language the web
 * build doesn't need, and vice versa for AdSense -- so each platform gets the page that
 * actually describes what it does, instead of one document hedging for every platform at once.
 *
 * Each URL is read fresh from Remote Config's `links` section (see [LinksConfig]) on every
 * access, falling back to the compiled default whenever Remote Config hasn't loaded, is
 * malformed, or the field is blank -- so a console typo opens the right page anyway instead
 * of a blank webview.
 */
object PrivacyPolicyUrls {
    val ANDROID: String get() = currentLinks().privacyPolicyAndroid.ifBlank { LinksConfig.DEFAULT.privacyPolicyAndroid }
    val IOS: String get() = currentLinks().privacyPolicyIos.ifBlank { LinksConfig.DEFAULT.privacyPolicyIos }
    val WEB: String get() = currentLinks().privacyPolicyWeb.ifBlank { LinksConfig.DEFAULT.privacyPolicyWeb }

    private fun currentLinks(): LinksConfig =
        AppConfig.parse(AppContainer.remoteConfig.getString(RemoteConfigKeys.APP_CONFIG)).links
}

/** The policy document this platform's Settings screen should open. */
expect fun currentPrivacyPolicyUrl(): String
